"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.RelatedTreeSelect = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = require("react");
var styled_components_1 = __importStar(require("styled-components"));
var react_2 = require("@escolalms/sdk/lib/react");
var TreeSelect_1 = require("../../atoms/TreeSelect");
var __1 = require("../../../");
var provider_1 = require("../../../theme/provider");
var utils_1 = require("../../../utils/utils");
function isLesson(el) {
    return el.lessons !== undefined;
}
var traverseTree = function (branch, currLabel) {
    return branch === null || branch === void 0 ? void 0 : branch.map(function (br) {
        var _a;
        if (isLesson(br)) {
            var label = "".concat(currLabel, " - ").concat(br.title);
            return {
                title: br.title,
                label: label,
                value: "EscolaLMS\\Courses\\Lesson:".concat(br.id),
                children: __spreadArray(__spreadArray([], traverseTree(br.lessons, label), true), traverseTree((_a = br === null || br === void 0 ? void 0 : br.topics) !== null && _a !== void 0 ? _a : [], label), true),
            };
        }
        return {
            title: br.title,
            label: "".concat(currLabel, " - ").concat(br.title),
            value: "EscolaLMS\\Courses\\Topic:".concat(br.id),
        };
    });
};
var textPartial = (0, styled_components_1.css)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  font-family: ", ";\n  font-size: 14px;\n  color: ", ";\n"], ["\n  font-family: ", ";\n  font-size: 14px;\n  color: ", ";\n"])), function (_a) {
    var theme = _a.theme;
    return (0, provider_1.getFontFromTheme)(theme).fontFamily;
}, function (_a) {
    var theme = _a.theme;
    return (0, utils_1.getStylesBasedOnTheme)(theme.mode, theme.white, theme.gray1);
});
var Label = styled_components_1.default.label(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  ", "\n"], ["\n  ", "\n"])), textPartial);
var Error = styled_components_1.default.div(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  ", ";\n  color: ", ";\n  margin-bottom: 1em;\n"], ["\n  ", ";\n  color: ", ";\n  margin-bottom: 1em;\n"])), textPartial, function (_a) {
    var theme = _a.theme;
    return theme.errorColor;
});
var RelatedTreeSelect = function (_a) {
    var _b = _a.treeDefaultExpandAll, treeDefaultExpandAll = _b === void 0 ? true : _b, id = _a.id, label = _a.label, error = _a.error, props = __rest(_a, ["treeDefaultExpandAll", "id", "label", "error"]);
    var program = (0, react_1.useContext)(react_2.EscolaLMSContext).program;
    var treeData = (0, react_1.useMemo)(function () {
        if (!program || !program.byId)
            return [];
        return Object.values(program.byId).reduce(function (acc, courseProgram) {
            var _a, _b;
            if (!courseProgram.value)
                return acc;
            return __spreadArray(__spreadArray([], acc, true), [
                {
                    title: courseProgram.value.title,
                    label: courseProgram.value.title,
                    value: "EscolaLMS\\Courses\\Course:".concat(courseProgram.value.id),
                    children: traverseTree((_b = (_a = courseProgram.value) === null || _a === void 0 ? void 0 : _a.lessons) !== null && _b !== void 0 ? _b : [], courseProgram.value.title),
                },
            ], false);
        }, []);
    }, [program]);
    return ((0, jsx_runtime_1.jsxs)(__1.Stack, __assign({ "$gap": 4 }, { children: [label && (0, jsx_runtime_1.jsx)(Label, __assign({ htmlFor: id }, { children: label })), (0, jsx_runtime_1.jsx)(TreeSelect_1.TreeSelect, __assign({}, props, { id: id, treeDefaultExpandAll: treeDefaultExpandAll, treeData: treeData })), error && (0, jsx_runtime_1.jsx)(Error, __assign({ "data-testid": "Error.".concat(id) }, { children: error }))] })));
};
exports.RelatedTreeSelect = RelatedTreeSelect;
var templateObject_1, templateObject_2, templateObject_3;
